import { AccordionTab } from "primereact/accordion";
import * as React from "react";
import "./PrwcAccordionTab.scss";

const PrwcAccordionTab = (props: any) => {

  const {children, ...restProps} = props;

  return (
      <AccordionTab {...restProps}>{children}</AccordionTab>
  );
};

export default PrwcAccordionTab;
